var _linearGradient, _linearGradient2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeAnimation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 507,
    width: 371,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-animation_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: -267.987,
    x2: -231.828,
    y1: 566.475,
    y2: -88.252
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#a053cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef59a5"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-animation_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 305.851,
    x2: 137.079,
    y1: 281.128,
    y2: 9.266
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.147,
    stopColor: "#ef59a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd9d60"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#home-animation_svg__a)",
    height: 305.851,
    rx: 15.098,
    transform: "matrix(-.86603 .5 0 1 264.875 .5)",
    width: 305.851
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#home-animation_svg__b)",
    height: 305.851,
    rx: 15.098,
    transform: "matrix(-.86603 .5 0 1 370.558 47.68)",
    width: 305.851
  }))));
}
export default SvgHomeAnimation;